// Brand data for OAuth login
export const BRAND_DATA = {
  logo: '/src/assets/FanFest_Logo.png',
  backgroundImage: '/src/assets/shutterstock_background.png',
};
